import defaultLogo from '../assets/logos/isotipo.svg';
import defaultLogoMobile from '../assets/logos/mobile.svg';
import defaultLpLogo from '../assets/logos/white.svg';
import defaultLpLogoPinned from '../assets/logos/black.svg';

const toCssUrl = (path) => `url("${path}")`;

/** Resolve /public paths with PUBLIC_URL; leave http(s) and webpack /static paths as-is. */
const resolveAssetPath = (path) => {
  if (!path) return path;
  if (/^(https?:|data:|blob:)/i.test(path)) return path;
  if (path.startsWith('/static/')) return path;

  const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  if (path.startsWith('/')) return `${publicUrl}${path}`;
  return path;
};

const applyBrandAssets = () => {
  if (typeof document === 'undefined') return;

  const logoPath = resolveAssetPath(
    process.env.REACT_APP_LOGO_PATH || defaultLogo
  );
  const logoPathMobile = resolveAssetPath(
    process.env.REACT_APP_LOGO_PATH_MOBILE ||
      process.env.REACT_APP_LOGO_PATH ||
      defaultLogoMobile
  );
  const lpLogoPath = resolveAssetPath(
    process.env.REACT_APP_LP_LOGO_PATH ||
      process.env.REACT_APP_LOGO_PATH ||
      defaultLpLogo
  );
  const lpLogoPathPinned = resolveAssetPath(
    process.env.REACT_APP_LP_LOGO_PATH_PINNED ||
      process.env.REACT_APP_LOGO_PATH ||
      defaultLpLogoPinned
  );

  const root = document.documentElement;
  root.style.setProperty('--app-logo-path', toCssUrl(logoPath));
  root.style.setProperty('--app-logo-path-mobile', toCssUrl(logoPathMobile));
  root.style.setProperty('--app-lp-logo-path', toCssUrl(lpLogoPath));
  root.style.setProperty(
    '--app-lp-logo-path-pinned',
    toCssUrl(lpLogoPathPinned)
  );
};

export default applyBrandAssets;
